export const leagacyRouteMap = {
  terms: {
    '/membership/terms/privacypolicy/thirdpartyDisplay': '/policies/privacy-notices/third-party',
    '/membership/terms/privacypolicy': '/policies/privacy-policies',
    '/membership/terms/termscontents': '/policies/terms-conditions/latest'
  },
  profile: {
    '/membership/contents/profile/delete-samsung-account': '/dashboard/profile/account/withdraw',
    '/membership/contents/profile/register-email-id': '/dashboard/profile/account/email-id',
    '/membership/contents/phonenumber/authentication': '/dashboard/profile/account/phone-id'
  },
  security: {
    '/membership/contents/security/2step-verification/gate': '/dashboard/security/two-step-verification',
    '/membership/contents/security/password/change-password': '/dashboard/security/reset-password',
    '/membership/contents/security/recent-security-events': '/dashboard/security/activities',
    '/membership/contents/security/recovery/gate': '/dashboard/security/recovery'
  },
  guide: {
    '/membership/guide/2step/faq': '/guide/two-step-verification/faq',
    '/membership/guide/2step/help': '/guide/two-step-verification/help',
    '/membership/guide/setup-2step-verification': '/guide/two-step-verification/help/setup',
    '/membership/guide/setup-authenticator-app': '/guide/two-step-verification/help/setup/authenticator-app',
    '/membership/guide/sign-in-using-verification-codes': '	/guide/two-step-verification/help/sign-in'
  },
  notice: {
    '/membership/notice/list': '/notices/legacies',
    '/membership/notice/notice-list': '/notices'
  },
  etc: {
    '/membership/etc/localeSelect.do': '/language',
    '/membership/notice/getBoardListInfo.do': '/notices',
    '/membership/etc/specialTC.do': '/policies/terms-conditions/latest'
  }
}
